module.exports = __webpack_public_path__ + "img/meetsanta6.f2d358c3.jpg";